import { useState, useEffect } from 'react';
// API
import Api from '../../API';
// helper
import {
  writeSearchDataToSessionStorage,
  getSearchDataFromSessionStorage,
  getLastSearchDataFromSessionStorage,
} from '../../utils/helpers';

const initialState = {
  books_list: [],
  total_results: 0,
  searchParams: {
    title: '',
    author: '',
  },
};

export const useSearchBooks = () => {
  const [state, setState] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const searchBooks = async (title, author) => {
    try {
      setLoading(true);
      setError('');

      const savedSearch = getSearchDataFromSessionStorage(title, author);
      if (savedSearch) {
        setState({ ...savedSearch });
        setLoading(false);

        return;
      }

      const books = await Api.searchBooks(title, author);

      if (books.total_results === 0) {
        setError('No Books Found !');
      }
      setState({ ...books });
      writeSearchDataToSessionStorage(title, author, books);
    } catch (error) {
      setError(error.message);
    }

    setLoading(false);
  };

  // set state to last search if found when first render
  useEffect(() => {
    const lastSearchState = getLastSearchDataFromSessionStorage();
    if (lastSearchState) {
      setState({ ...lastSearchState });
    }
  }, []);

  return { state, loading, error, searchBooks };
};
